import { render } from "./BaseRoundedButton.vue?vue&type=template&id=45a81908&scoped=true"
import script from "./BaseRoundedButton.vue?vue&type=script&lang=js"
export * from "./BaseRoundedButton.vue?vue&type=script&lang=js"

import "./BaseRoundedButton.vue?vue&type=style&index=0&id=45a81908&scoped=true&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a81908"]])

export default __exports__